import { PropsWithChildren, useRef } from 'react'

import { createSchemaField } from '@formily/react'

import { GenericalRecord } from '@eastcoal/common/types/utilities'

import { Form } from '../Form'
import { FormGrid } from '../FormGrid'
import { FormLayout } from '../FormLayout'

import { useSmartLayout } from './hooks/useSmartLayout'
import { useTransformSchema } from './hooks/useTransformSchema'
import { SchemaFormProps } from './interface'

const SchemaField = createSchemaField()

export const SchemaForm = <T extends GenericalRecord>({
  className,
  style,
  grid,
  layout,

  /**
   * SchemaForm
   */
  schema: externalSchema,
  scope,
  bodyClassName,
  footer,
  children,

  /**
   * Form
   */
  form,
  ...formProps
}: PropsWithChildren<SchemaFormProps<T>>) => {
  const schema = useTransformSchema(externalSchema)

  const content = (
    <>
      <SchemaField schema={schema} scope={scope} />
      {children}
    </>
  )

  const containerRef = useRef<HTMLDivElement>(null)

  const smartLayout = useSmartLayout({
    layout,
    schema: externalSchema
  })

  const body =
    grid === false ? (
      <div className={bodyClassName}>{content}</div>
    ) : (
      <FormGrid {...grid} className={bodyClassName}>
        {content}
      </FormGrid>
    )

  return (
    <div ref={containerRef} className={className} style={style}>
      <Form form={form} {...formProps}>
        <FormLayout {...smartLayout}>
          {body}
          {footer}
        </FormLayout>
      </Form>
    </div>
  )
}
